import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HookType } from '../enum/hooks.enum'
import { AccessControlService } from '../services/access-control.service';
import { WebhookService } from '../services/webhook.service';
import Swal from 'sweetalert2';

type WebHook = { _id: string, url: string, active: boolean, type: HookType, application_id: string };
type PermissionUpdateWebHook={_id:string,url:string,active:boolean,application_id:string}
@Component({
  selector: 'app-web-hooks',
  templateUrl: './web-hooks.component.html',
  styleUrls: ['./web-hooks.component.css']
})
export class WebHooksComponent implements OnInit {
  model: Array<WebHook> = [];
  permissionWebHookModel:Partial< PermissionUpdateWebHook > = {
    url:'',
    active:false,
    application_id:''
  };
  application_name: string;
  appId: string;
  clientId: string;
  reqStatus: string;
  saveStatus: string="Save";
  index: number;
  applicationList: Array<{ application_name: string, _id: string }>;
  isLoading=false;

  @ViewChild("containerRef", { read: ViewContainerRef }) containerRef: ViewContainerRef;
  @ViewChild("hookTemplate", { read: TemplateRef }) templateRef: TemplateRef<any>;
  constructor(private router: ActivatedRoute, private webhookService: WebhookService, private toastrService: ToastrService, private accessControlService: AccessControlService) {
    this.router.queryParams.subscribe((params: Params) => {
      this.application_name = params["appname"];
    })
    this.router.params.subscribe((params: Params) => {
      this.appId = params["applicationId"];
    });
    this.clientId = localStorage.getItem("org_id");
    this.accessControlService.getClient(this.clientId, 0).subscribe((res: any) => {
      if (!res.error) {
        this.applicationList = res.data['applications'];
      }
    })
    this.fetchHooks();
  }

  ngOnInit() {
  }
  fetchHooks() {
    this.isLoading=true;
    this.webhookService.getHookDetails({ clientId: this.clientId, applicationId: this.appId }).
      subscribe((res: { error: boolean, hooks: Array<WebHook>, permissionUpdateHook:Partial<PermissionUpdateWebHook>}) => {
        if (!res.error && res.hooks.length > 0)
          this.model = res.hooks;//.find(x => x.type == HookType.POST_USER_CREATION);
        if (this.model.length == 0) {
          this.model.push({ _id: null, url: null, active: false, type: HookType.POST_USER_CREATION, application_id: null });
        }
        if (this.model.length > 0) {
          this.renderHooks();
        }
        this.permissionWebHookModel = res.permissionUpdateHook || {url:'',active:false,application_id:''}
        this.isLoading=false;

      }, error => {
        this.isLoading=false;

      });
  }
  saveHook() {
    this.saveStatus="Saving.."
    this.webhookService.updateHook({'webHook':this.model,'permissionWebHook':this.permissionWebHookModel}, { clientId: this.clientId, applicationId: this.appId }).
      subscribe((res: { error: boolean, errorMessage }) => {
        if (res.error)
          this.toastrService.error(res.errorMessage)
        else
          this.toastrService.success("Records updated successfully.");
      },error=>{

      },()=>{
        this.saveStatus="Save"
      })
    // }
  }
  testHook(index: number) {
    this.reqStatus = "Sending..";
    this.toastrService.success(this.reqStatus);
    this.webhookService.testHook(this.model[index]).
      subscribe((res: any) => {
        this.reqStatus = "Send";
        this.toastrService.clear();
        this.toastrService.info(JSON.stringify(res));
      }, error => {
        this.reqStatus = "Failed";
        this.toastrService.error(error.message)
      })
  }
  addHook() {
    this.model.push({ _id: null, url: null, active: false, type: HookType.POST_USER_CREATION, application_id: null });
    this.containerRef.createEmbeddedView(this.templateRef, { model: this.model, index: this.model.length - 1 });
  }
  renderHooks() {
    this.model.forEach((hook, index) => {
      this.containerRef.createEmbeddedView(this.templateRef, { model: this.model, index: index });
    })
  }
  onDelete(index) {
    Swal({
      title: 'Are you sure you want to delete?',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.model.splice(index, 1);
        this.containerRef.remove(index);
      }

    })

  }

}
